/**
 * Maps a WF flow meter row to the consumption microservice `spotId`.
 * Legacy API used `spot_id`; v2 expects `spotId` matching snapshot `cartridges[].spotId`.
 */
export const getCartridgeSpotId = flowMeter => {
  if (!flowMeter) {
    return undefined;
  }

  const raw =
    flowMeter.spotId ??
    flowMeter.spot_id ??
    flowMeter.spot_water_filter_head_id ??
    flowMeter.spot_reverse_osmosis_filter_id ??
    flowMeter.SpotsWaterFilter?.id ??
    flowMeter.SpotsReverseOsmosisFilter?.id;

  if (raw == null || raw === '') {
    return undefined;
  }

  return String(raw);
};

export const buildCartridgeConsumptionRequest = ({
  device_id,
  flowMeter,
  water_filter_head_id,
}) => {
  const spotId = getCartridgeSpotId(flowMeter);

  return {
    device_id,
    water_filter_head_id,
    ...(flowMeter?.last_replaced ? { from: flowMeter.last_replaced } : {}),
    ...(spotId ? { spotId } : {}),
  };
};
